// Display a cookie banner
//
// Clicking "OK" enables analytics cookies
//
// Clicking "Preferences" opens the Cookie Control side panel

'use strict'

const cookie = require('cookie_js')

const ccConfig = require('./cookieControl')
const googleAnalytics = require('./googleAnalytics')

window.addEventListener('DOMContentLoaded', function () {
  const TEN_YEARS = 365 * 10
  const COOKIE_NEVER_ASK_AGAIN = 'cookies-never-ask-again'
  const COOKIE_ONCE = 'cookies-analytics-cookies-have-been-enabled-by-default'

  const banner = document.querySelector('.cookie-banner-container')

  const buttonPreferences = banner.querySelector('button.preferences')
  const buttonOk = banner.querySelector('button.ok')

  const optionalCookies = [
    {
      name: 'analytics',
      label: 'Analytics',
      description:
        "We'd like to set Google Analytics cookies to help us to improve our website by collecting and reporting information on how you use it. For more information on how these cookies work please see our 'Cookies page'. The cookies collect information in an anonymous form.",
      cookies: ['_ga', '_gat', '_gid'],
      // This line doesn't seem to work
      recommendedState: true,
      onAccept: function () {
        googleAnalytics.enable()
        bannerHide()
      },
      onReject: function () {
        googleAnalytics.disable()
        bannerHide()
      },
    },
  ]

  const bannerHide = function () {
    banner.style.display = 'none'
  }

  const bannerShow = function () {
    banner.style.display = 'block'
  }

  const onLoad = function () {
    if (typeof cookie.get(COOKIE_NEVER_ASK_AGAIN) !== 'undefined') {
      // Don't ask the user again
      return
    }

    // Turn on analytics cookies once and only once
    if (typeof cookie.get(COOKIE_ONCE) === 'undefined') {
      cookie.set(COOKIE_ONCE, 'true', {
        expires: TEN_YEARS,
      })
      consentToAnalyticsCookies()
    }
    bannerShow()
  }

  const loadCookieControl = function () {
    var config = ccConfig
    config.onLoad = onLoad

    config.optionalCookies = optionalCookies

    // Whitelist our own cookie so we can hide the cookie notice
    config.necessaryCookies = [COOKIE_NEVER_ASK_AGAIN, COOKIE_ONCE]

    window.CookieControl.load(config)
  }

  const consentToAnalyticsCookies = function () {
    // Ensure we're turning the consent ON
    if (!window.CookieControl.getCategoryConsent(getCookieIndex('analytics'))) {
      window.CookieControl.toggleCategory(getCookieIndex('analytics'))
    }
  }

  const getCookieIndex = function (name) {
    for (var i = 0; i < optionalCookies.length; i++) {
      if (optionalCookies[i].name === name) {
        return i
      }
    }

    console.warn('Oops: getCookieIndex() failed')
  }

  const neverAskAgain = function () {
    cookie.set(COOKIE_NEVER_ASK_AGAIN, 'true', {
      expires: TEN_YEARS,
    })
  }

  buttonOk.addEventListener('click', function () {
    consentToAnalyticsCookies()

    bannerHide()

    neverAskAgain()
  })

  buttonPreferences.addEventListener('click', function () {
    // Open cookie control side panel
    window.CookieControl.open()

    bannerHide()

    neverAskAgain()

    document.getElementById('ccc-recommended-settings').focus()
  })

  loadCookieControl()
})
